import { FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, FormHelperText, Typography } from "@mui/material";
import { Controller, useWatch } from "react-hook-form";
import './../App.css';

export default function MultiSelect({name, control, errors, question, helper, options, required, max}) {

    const checkboxIds = useWatch({ control, name: name }) || [];

    const handleChange = (event, onChange) => {
        const newArray = [ ...checkboxIds ];
        const item = event.target.name;
        if (newArray.length > 0) {
            const index = newArray.findIndex(x => x === item);

            if (index === -1) {
                newArray.push(item);
            } else {
                newArray.splice(index, 1);
            }
        } else {
            newArray.push(item);
        }
        onChange(newArray); 
      };

    const setDisabled = (option) => {
        if(checkboxIds.length >= max && !checkboxIds.includes(option))
            return true
        return false
    };
    
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={[]}
            render={({ field : {onChange} }) => 
            <FormControl error={errors? true: false}>
                <FormLabel required={required}>{question}</FormLabel>
                {helper? helper.map(text => (
                    <FormHelperText key={text} className="wrap-it helper">{text}</FormHelperText>
                )) : null}
                <FormGroup>
                {options.map(option => (
                    <FormControlLabel key={option} 
                    control={<Checkbox 
                        onChange={(event) => handleChange(event, onChange)}
                        disabled={setDisabled(option)}
                        name={option}
                        checked={checkboxIds.includes(option)}/>} 
                        label={option}/>
                ))}
                </FormGroup>
                <Typography className="font-14 error-message">
                    {errors?.message}
                </Typography>
            </FormControl>
            }
        />
    );
}